import ProductTransformer from './ProductTransformer';

export default class ProductChangeSummaryTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteChangeSummary') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    [
      'productName',
      'priceInformation',
      'promotionPriceOverrideText',
      'regularPriceOverrideText',
      'minimumCommitmentPeriodOverrideText',
      'minimumCommitmentPeriodText',
      'productDescriptionChangeSummary',
      'headerTitleProductChangeSummary',
      'promotionPriceOverrideText',
      'regularPriceOverrideText',
      'emailTextProductChangeSummary',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
